(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-zwei-klick"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-youtube-two-click]').forEach((container) => {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const button = container.querySelector('.youtube-consent__button');
    const frame = container.querySelector('.youtube-consent__frame');

    button?.addEventListener('click', () => {
      const iframe = document.createElement('iframe');
      iframe.className = 'youtube-consent__iframe';
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(container.dataset.videoId)}?rel=0`;
      iframe.title = container.dataset.videoTitle;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      frame.replaceChildren(iframe);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
